import React, { useEffect, useState } from 'react'
import { useHits, useInstantSearch } from 'react-instantsearch'
import CommonUtils from '@bodeboca/utils'
import ApiService from '@bodeboca/api'
import GtmApi from '@bodeboca/gtm/api'
import VerticalBanner from '@bodeboca/algolia/components/vertical_banner'
import HorizontalBanner from '@bodeboca/algolia/components/horizontal_banner'
import './style.scss'
import Product from '@bodeboca/algolia/components/product'
import {useTranslation} from "react-i18next"

function CustomHits(props) {
  const {
    items, results, sendEvent,
  } = useHits(props)
  const [favourites, setFavourites] = useState([])
  const [emptySearchHtml, setEmptySearchHtml] = useState('')
  const showEmptySearch = () => {
    return items.length === 0 && ApiService.isContext('search') && results['__isArtificial'] === undefined
  }
  const [rowSize, setRowSize] = useState(CommonUtils.getRowSize())
  const {uiState} = useInstantSearch()
  const {t} = useTranslation()
  useState([])
  const banners = ApiService.getBanners()
  const [userFlaggedItems, setUserFlaggedStockItems] = useState([])
  const [availableBundlesToFlag, setAvailableBundlesToFlag] = useState([])

  // Subscribe to size changes.
  useEffect(() => {
    function handleResize() {
      let newRowSize = CommonUtils.getRowSize()
      setRowSize(newRowSize)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const itemsWithBanners = () => {

    let page = results.page
    let indexKey = Object.keys(uiState)
    let stateKeys = Object.keys(uiState[indexKey])
    if (page === 0 && stateKeys.indexOf('hierarchicalMenu') === -1 && stateKeys.indexOf('menu') === -1 && stateKeys.indexOf('refinementList') === -1 && stateKeys.indexOf('range') === -1) {
      // Horizontal do not count for offset.
      let numHorizontalBanners = 0
      let numVerticalElementsInyected = 0
      let injectedBannerIds = []
      let resultItems = []
      let lastInyectedElement = {}
      for (let i = 0; i < items.length; i++) {
        let keepHorizontalReference = undefined
        if (injectedBannerIds.length !== banners.length) {
          for (let b = 0; b < banners.length; b++) {
            if (!injectedBannerIds.includes(banners[b]['id']) && banners[b]['type'] === 'cp_horizontal' && parseInt(banners[b]['position']) - 1 <= i && numVerticalElementsInyected % rowSize === 0 && lastInyectedElement['type'] !== 'cp_horizontal') {
              injectedBannerIds.push(banners[b]['id'])
              resultItems.push(banners[b])
              lastInyectedElement = banners[b]
              numHorizontalBanners = numHorizontalBanners + 1
            } else if (!injectedBannerIds.includes(banners[b]['id']) && banners[b]['type'] === 'cp_horizontal' && parseInt(banners[b]['position']) - 1 <= i) {
              keepHorizontalReference = banners[b]
            }
            if (!injectedBannerIds.includes(banners[b]['id']) && banners[b]['type'] === 'cp_vertical' && parseInt(banners[b]['position']) - 1 <= i) {
              injectedBannerIds.push(banners[b]['id'])
              numVerticalElementsInyected = numVerticalElementsInyected + 1
              resultItems.push(banners[b])
              lastInyectedElement = banners[b]
            }

            if (keepHorizontalReference !== undefined && numVerticalElementsInyected % rowSize === 0 && lastInyectedElement['type'] !== 'cp_horizontal') {
              injectedBannerIds.push(keepHorizontalReference['id'])
              resultItems.push(keepHorizontalReference)
              lastInyectedElement = keepHorizontalReference
              numHorizontalBanners = numHorizontalBanners + 1
              keepHorizontalReference = undefined
            }
          }
        }
        resultItems.push(items[i])
        lastInyectedElement = items[i]
        numVerticalElementsInyected = numVerticalElementsInyected + 1
      }
      return resultItems
    } else {
      return items
    }
  }

  useEffect(() => {
    if (items.length > 0) {
      GtmApi.onListView(items)
    }
    if (!ApiService.isContext('cp_section')) {
      CommonUtils.setIsLoading(false)
    }
    if (items.length > 0) {
      CommonUtils.setIsLoading(false)
    }
    else if (items.length === 0 && results['__isArtificial'] === undefined) {
      if (ApiService.isContext('cp_section')) {
        CommonUtils.notFound()
      } else {
        if (emptySearchHtml === '') {
          ApiService.getEmptySearchMenu().then((html) => {
            setEmptySearchHtml(html)
          })
        }
        CommonUtils.setIsLoading(false)
      }
    }
  }, [results])

  useEffect(() => {

    ApiService.getFavouritesArray().then((data) => {
      setFavourites(data)
    })
    ApiService.getFlaggedStockItems().then((data) => {
      setUserFlaggedStockItems(data.items)
      if (data.available_bundles) {
        setAvailableBundlesToFlag(data.available_bundles)
      }
    })
  }, [])

  return (<>
    {itemsWithBanners().length === 0 && showEmptySearch() && ApiService.isContext('search') && results.query !== undefined &&
    <div className={'empty-results-for-query'}>{t('Sorry, no products available')}</div>}
    {itemsWithBanners().length === 0 && showEmptySearch() && ApiService.isContext('search') &&
      <div
        className={'no-results-links'}
        dangerouslySetInnerHTML={{ __html: emptySearchHtml }}/>}
    <ol
      className={'product-list'}>
      {itemsWithBanners().length > 0 && itemsWithBanners().map((hit) => (<>
        {hit['type'] === 'cp_vertical' && <VerticalBanner
          {...hit}
          key={'banner_' + hit['id']}/>}
        {hit['type'] === 'cp_horizontal' && <HorizontalBanner
          {...hit}
          key={'banner_' + hit['id']}/>}
        {hit['type'] === undefined && <Product
          availableBundlesToFlag={availableBundlesToFlag}
          favourites={favourites}
          hit={hit}
          key={hit['product_id']}
          sendEvent={sendEvent}
          userFlaggedItems={userFlaggedItems}/>}
      </>))}
    </ol>
  </>)
}

export default CustomHits
